import uiCopy from './service-ui-copy.json';
/* Deliberate service enquiries only. No personal data is stored or logged. */
(() => {
  'use strict';

  if (/(^|\/)[^/]*rolex[^/]*(\/|$)/i.test(window.location.pathname)) return;
  const root = document.querySelector('.sv-page[data-sv-locale]');
  if (!root) return;
  const locale = root.dataset.svLocale === 'fr' ? 'fr' : 'en';
  const copy = uiCopy[locale];
  const topicField = root.querySelector('[name="topic"]');
  const topics = new Set(topicField ? (topicField.options ? [...topicField.options].map(option => option.value) : [topicField.value]) : []);
  const locations = new Set(['Cambridge', 'Conestoga Mall']);
  const methods = new Set(['Phone', 'Email']);
  const clean = value => typeof value === 'string' ? value.trim() : '';
  const singleLine = (value, limit) => value.length <= limit && !/[\u0000-\u001f\u007f]/.test(value);
  let inFlight = false;

  function pageUrl() {
    try {
      const page = new URL(window.location.href);
      return ['https:', 'http:'].includes(page.protocol) ? page.origin + page.pathname : '';
    } catch {
      return '';
    }
  }

  function createPayload(values) {
    const input = values && typeof values === 'object' && !Array.isArray(values) ? values : {};
    const fields = {};
    for (const name of ['firstName', 'lastName', 'emailAddress', 'phoneNumber', 'contactMethodPreference', 'location', 'topic', 'message']) {
      fields[name] = clean(input[name]);
    }
    const errors = {};
    if (!fields.firstName || !singleLine(fields.firstName, 100)) errors.firstName = copy.errors.firstName;
    if (!fields.lastName || !singleLine(fields.lastName, 100)) errors.lastName = copy.errors.lastName;
    if (!singleLine(fields.emailAddress, 254) || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.emailAddress)) errors.emailAddress = copy.errors.emailAddress;
    const phoneDigits = fields.phoneNumber.replace(/\D/g, '').length;
    if (!singleLine(fields.phoneNumber, 50) || phoneDigits < 7 || phoneDigits > 20) errors.phoneNumber = copy.errors.phoneNumber;
    if (!methods.has(fields.contactMethodPreference)) errors.contactMethodPreference = copy.errors.contactMethodPreference;
    if (!locations.has(fields.location)) errors.location = copy.errors.location;
    if (!topics.has(fields.topic)) errors.topic = copy.errors.topic;
    if (fields.message.length > 2000 || /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/.test(fields.message)) errors.message = copy.errors.message;
    if (input.agreeToTerms !== true) errors.agreeToTerms = copy.errors.agreeToTerms;
    if (Object.keys(errors).length) return { ok: false, status: 'invalid', errors };

    const request = (fields.contactMethodPreference === 'Phone' ? copy.requestPhone : copy.requestEmail).replace('{topic}', fields.topic);
    return {
      ok: true,
      payload: {
        ...fields,
        message: fields.message || request,
        agreeToTerms: true,
        marketingConsent: false,
        url: pageUrl(),
        lang: locale,
      },
    };
  }

  const unknown = code => ({
    ok: false,
    status: 'unknown',
    code,
    message: copy.unknown.replace('{phone}', ''),
  });

  async function submit(payload, csrfToken) {
    const checked = createPayload(payload);
    if (!checked.ok) return { ...checked, code: 'INVALID_FIELDS', message: copy.errors.invalid };
    const token = clean(csrfToken);
    if (!token || !singleLine(token, 8192)) {
      return { ok: false, status: 'invalid', code: 'MISSING_TOKEN', message: copy.errors.token };
    }
    if (inFlight) return { ok: false, status: 'invalid', code: 'IN_PROGRESS', message: copy.errors.inProgress };

    inFlight = true;
    let timer;
    try {
      const controller = new AbortController();
      const timeout = new Promise(resolve => {
        timer = setTimeout(() => {
          controller.abort();
          resolve(unknown('TIMEOUT'));
        }, 12000);
      });
      const request = (async () => {
        try {
          const response = await fetch('/api/forms/contact', {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            redirect: 'error',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'x-csrf-token': token,
            },
            body: JSON.stringify(checked.payload),
            signal: controller.signal,
          });
          if (response.redirected || response.type === 'opaqueredirect') return unknown('REDIRECT');
          if (response.status !== 200) return unknown('SERVER_RESPONSE');
          const type = clean(response.headers.get('content-type')).split(';')[0].toLowerCase();
          if (type !== 'application/json') return unknown('INVALID_RESPONSE');
          const data = await response.json();
          if (!data || Array.isArray(data) || data.message !== 'email sent') return unknown('INVALID_RESPONSE');
          return { ok: true, status: 'success' };
        } catch {
          return unknown('NETWORK');
        }
      })();
      return await Promise.race([request, timeout]);
    } catch {
      return unknown('UNAVAILABLE');
    } finally {
      clearTimeout(timer);
      inFlight = false;
    }
  }

  window.RaffiServiceRequests = Object.freeze({ createPayload, submit });
})();
